import {
  Animation,
  SPRING,
  animationSpeed,
  getTranslate,
} from './utils.svelte';
import { springIn } from './springs';

const dropInAnimation = new Animation();

export const dropIn = (
  node: HTMLElement,
  { tileHeight = 60, row = 0, rowOffset = 2 },
) => {
  const [translate_x, translate_y] = getTranslate(node);
  // const duration = flipDuration(rowOffset * tileHeight);

  const interpOpacity = (t: number) =>
    t < (rowOffset - 1) / rowOffset ? 0 : t * rowOffset - (rowOffset - 1);

  const delay = (1 + row) * 30;
  const spring = animationSpeed.spring;
  const { duration, tickToValue } = springIn(rowOffset * tileHeight, 0, {
    ...SPRING,
    fps: spring,
  });
  dropInAnimation.queue(duration + delay);

  return {
    delay: Math.max(delay, 0),
    duration,
    css: (t: number, u: number) => `
      opacity: ${t};
      translate: none;
      transform: translate3d(${translate_x}px, ${translate_y - tickToValue(t)}px, 0);
    `,
  };
};
